<template>
  <div class="saved-research-list">
    <h3>Saved Research:</h3>
    <ul class="research-list">
      <li v-for="(item, index) in savedResearches" :key="index" class="research-item">
        <div class="research-header">
          <span class="research-date">{{ item.date }}</span>
          <div class="research-actions">
            <button class="action-button" @click="$emit('edit-research', index)">Edit</button>
            <button class="action-button" @click="$emit('delete-research', index)">Delete</button>
          </div>
        </div>
        <ul class="research-details">
          <li>Abductee: {{ item.abductee }}</li>
          <li>D.O.B: {{ item.abducteedob }}</li>
          <li>Abductee New: {{ item.abducteeNew }}</li>
          <li>Abductee D.O.B New: {{ item.abducteeNewdob }}</li>
          <li>Abductee New Social Media: {{ item.abducteeNewSocialMedia }}</li>
          <li>Missing Since New: {{ item.missingSinceNew }}</li>
          <li>Abductor: {{ item.abductor }}</li>
          <li>Motive: {{ item.motive }}</li>
          <li>Abductee Recovery Rescuer: {{ item.abducteeRecoveryRescuer }}</li>
          <li>Abductor D.O.B: {{ item.abductordob }}</li>
          <li>Family Country: {{ item.familyCountry }}</li>
          <li>Missing Since: {{ item.missingSince }}</li>
          <li>Abductee Social Media: {{ item.abducteeSocialMedia }}</li>
          <li>Abductor Social Media: {{ item.abductorSocialMedia }}</li>
          <li>Last Known Address: {{ item.lastKnownAddress }}</li>
          <li>Case Type: {{ item.caseType }}</li>
          <li>Last Saved Query: {{ item.lastSavedQuery }}</li>
          <li>Last Saved URL: {{ item.lastSavedUrl }}</li>
          <li v-if="item.abducteeImage">
            Abductee Image: <a href="#" @click.prevent="openImageInNewTab(item.abducteeImage)">Open Image</a>
          </li>
          <li v-if="item.abducteeImageNew">
            Abductee Image New: <a href="#" @click.prevent="openImageInNewTab(item.abducteeImageNew)">Open Image</a>
          </li>
          <li v-if="item.abductorImage">
            Abductor Image: <a href="#" @click.prevent="openImageInNewTab(item.abductorImage)">Open Image</a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    savedResearches: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openImageInNewTab(imageUrl) {
      const newWindow = window.open();
      newWindow.document.write(`<img src="${imageUrl}" />`);
    },
  },
};
</script>

<style scoped>
.saved-research-list {
  background-color: #1c1e24;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  min-width: 420px;
  width: 100%;
}

h3 {
  color: #00d1b2;
  font-family: 'Orbitron', sans-serif;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 20px;
}

.research-list {
  list-style-type: none;
  padding: 0;
}

.research-item {
  background: linear-gradient(135deg, #2a2d34 0%, #24272e 100%);
  border: 1px solid #3a3f4b;
  border-radius: 8px;
  margin-bottom: 15px;
  padding: 15px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.research-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
}

.research-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.research-date {
  color: #ff6f61;
  font-weight: bold;
  font-size: 1.1em;
  font-family: 'Orbitron', sans-serif;
}

.research-actions {
  display: flex;
  gap: 10px;
}

.action-button {
  background-color: #00d1b2;
  border: none;
  border-radius: 4px;
  color: #1c1e24;
  cursor: pointer;
  font-weight: bold;
  padding: 5px 10px;
  transition: background-color 0.3s ease;
}

.action-button:hover {
  background-color: #00bfa5;
}

.research-details {
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-family: 'Courier New', monospace;
}

.research-details li {
  padding: 5px 0;
}

.research-details a {
  color: #00d1b2;
  text-decoration: underline;
  cursor: pointer;
}

.research-details a:hover {
  text-decoration: none;
}
</style>
